export default __webpack_public_path__ + "static/media/blkwoman2.2598300d.png";